import React, { useState } from 'react';
const Footer = () => {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const openModal = (modalType: string) => {
    setActiveModal(modalType);
    document.body.style.overflow = 'hidden';
  };
  const closeModal = () => {
    setActiveModal(null);
    document.body.style.overflow = 'auto';
  };
  return <footer className="w-full bg-gray-800 text-white py-12" data-id="element-109">
      <div className="container mx-auto px-4" data-id="element-110">
        <div className="max-w-5xl mx-auto" data-id="element-111">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-8" data-id="element-112">
            <div data-id="element-113">
              <h3 className="text-xl font-bold mb-4" data-id="element-114">La Cena Que Te Salva</h3>
              <p className="text-gray-300 mb-4" data-id="element-115">
                El sistema secreto de las mamás latinas para cocinar sano,
                rápido y delicioso, por menos de $5 al día.
              </p>
              <p className="text-gray-400 text-sm" data-id="element-116">
                © 2023 La Cena Que Te Salva. Todos los derechos reservados.
              </p>
            </div>
            <div data-id="element-117">
              <h3 className="text-xl font-bold mb-4" data-id="element-118">Información Legal</h3>
              <p className="text-gray-300 mb-4" data-id="element-119">
                Los resultados pueden variar. Las estrategias de ahorro dependen
                de la ubicación geográfica, disponibilidad de productos y
                precios locales.
              </p>
              <div className="flex flex-wrap gap-4 text-sm text-gray-400" data-id="element-120">
                <button onClick={() => openModal('terms')} className="hover:text-orange-300 cursor-pointer" data-id="element-121">
                  Términos y Condiciones
                </button>
                <button onClick={() => openModal('privacy')} className="hover:text-orange-300 cursor-pointer" data-id="element-122">
                  Política de Privacidad
                </button>
              </div>
            </div>
          </div>
          <div className="text-center pt-8 border-t border-gray-700" data-id="element-123">
            <p className="text-gray-400 text-sm" data-id="element-124">
              Este producto es un ebook digital. No se enviarán productos
              físicos. Después de la compra, recibirás acceso inmediato al área
              de miembros donde podrás descargar todos los materiales.
            </p>
          </div>
        </div>
      </div>
      {/* Terms and Conditions Modal */}
      {activeModal === 'terms' && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-125">
          <div className="bg-white text-gray-800 rounded-lg max-w-3xl max-h-[80vh] overflow-y-auto p-6 relative" data-id="element-126">
            <button onClick={closeModal} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800" aria-label="Cerrar" data-id="element-127">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-128">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-129" />
              </svg>
            </button>
            <h2 className="text-2xl font-bold mb-4" data-id="element-130">Términos y Condiciones</h2>
            <div className="space-y-4" data-id="element-131">
              <p data-id="element-132">Última actualización: 1 de enero de 2023</p>
              <h3 className="text-xl font-semibold" data-id="element-133">
                1. Aceptación de los Términos
              </h3>
              <p data-id="element-134">
                Al acceder y utilizar "La Cena Que Te Salva", usted acepta estar
                sujeto a estos Términos y Condiciones, todas las leyes y
                regulaciones aplicables. Si no está de acuerdo con alguno de
                estos términos, está prohibido usar o acceder a este sitio.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-135">2. Uso de la Licencia</h3>
              <p data-id="element-136">
                Se concede permiso para descargar temporalmente una copia de los
                materiales (información o software) en el sitio de "La Cena Que
                Te Salva" para visualización transitoria personal y no comercial
                únicamente. Esta es la concesión de una licencia, no una
                transferencia de título.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-137">
                3. Descargo de Responsabilidad
              </h3>
              <p data-id="element-138">
                Los materiales en el sitio de "La Cena Que Te Salva" se
                proporcionan "tal cual". No ofrecemos garantías, expresas o
                implícitas, y por la presente rechazamos y negamos todas las
                demás garantías, incluyendo, sin limitación, garantías
                implícitas o condiciones de comerciabilidad, idoneidad para un
                propósito particular, o no infracción de propiedad intelectual u
                otra violación de derechos.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-139">4. Limitaciones</h3>
              <p data-id="element-140">
                En ningún caso "La Cena Que Te Salva" o sus proveedores serán
                responsables por cualquier daño (incluyendo, sin limitación,
                daños por pérdida de datos o beneficio, o debido a la
                interrupción del negocio) que surja del uso o incapacidad de
                usar los materiales en el sitio, incluso si "La Cena Que Te
                Salva" o un representante autorizado ha sido notificado
                oralmente o por escrito de la posibilidad de tal daño.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-141">5. Revisiones y Erratas</h3>
              <p data-id="element-142">
                Los materiales que aparecen en el sitio de "La Cena Que Te
                Salva" podrían incluir errores técnicos, tipográficos o
                fotográficos. "La Cena Que Te Salva" no garantiza que cualquiera
                de los materiales en su sitio web sean precisos, completos o
                actuales.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-143">6. Enlaces</h3>
              <p data-id="element-144">
                "La Cena Que Te Salva" no ha revisado todos los sitios enlazados
                a su sitio web y no es responsable por el contenido de cualquier
                sitio enlazado. La inclusión de cualquier enlace no implica
                endoso por parte de "La Cena Que Te Salva" del sitio. El uso de
                cualquier sitio web enlazado es bajo el propio riesgo del
                usuario.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-145">
                7. Modificaciones a los Términos de Servicio
              </h3>
              <p data-id="element-146">
                "La Cena Que Te Salva" puede revisar estos términos de servicio
                para su sitio web en cualquier momento sin previo aviso. Al usar
                este sitio web, usted acepta estar sujeto a la versión actual de
                estos términos de servicio.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-147">8. Ley Aplicable</h3>
              <p data-id="element-148">
                Cualquier reclamación relacionada con el sitio web de "La Cena
                Que Te Salva" se regirá por las leyes de [País] sin tener en
                cuenta sus disposiciones de conflicto de leyes.
              </p>
            </div>
          </div>
        </div>}
      {/* Privacy Policy Modal */}
      {activeModal === 'privacy' && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-149">
          <div className="bg-white text-gray-800 rounded-lg max-w-3xl max-h-[80vh] overflow-y-auto p-6 relative" data-id="element-150">
            <button onClick={closeModal} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800" aria-label="Cerrar" data-id="element-151">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-152">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-153" />
              </svg>
            </button>
            <h2 className="text-2xl font-bold mb-4" data-id="element-154">Política de Privacidad</h2>
            <div className="space-y-4" data-id="element-155">
              <p data-id="element-156">Última actualización: 1 de enero de 2023</p>
              <p data-id="element-157">
                En "La Cena Que Te Salva", accesible desde nuestro sitio web,
                una de nuestras principales prioridades es la privacidad de
                nuestros visitantes. Este documento de Política de Privacidad
                contiene los tipos de información que se recopilan y registran
                por "La Cena Que Te Salva" y cómo la usamos.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-158">
                Información que Recopilamos
              </h3>
              <p data-id="element-159">
                Cuando se registra en nuestro sitio, como parte del proceso,
                recopilamos la información personal que nos proporciona, como su
                nombre, dirección y dirección de correo electrónico. Su
                información personal será utilizada solo para los motivos
                específicos indicados anteriormente.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-160">Archivos de Registro</h3>
              <p data-id="element-161">
                "La Cena Que Te Salva" sigue un procedimiento estándar de uso de
                archivos de registro. Estos archivos registran a los visitantes
                cuando visitan sitios web. Todas las empresas de alojamiento
                hacen esto como parte de los servicios de análisis de
                alojamiento. La información recopilada por los archivos de
                registro incluye direcciones de protocolo de Internet (IP), tipo
                de navegador, proveedor de servicios de Internet (ISP), marca de
                fecha y hora, páginas de referencia/salida, y posiblemente el
                número de clics.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-162">Cookies y Web Beacons</h3>
              <p data-id="element-163">
                Como cualquier otro sitio web, "La Cena Que Te Salva" utiliza
                'cookies'. Estas cookies se utilizan para almacenar información,
                incluyendo las preferencias de los visitantes, y las páginas del
                sitio web que el visitante accedió o visitó. La información se
                utiliza para optimizar la experiencia de los usuarios
                personalizando el contenido de nuestra página web según el tipo
                de navegador de los visitantes y/u otra información.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-164">
                Políticas de Privacidad de Socios Publicitarios
              </h3>
              <p data-id="element-165">
                Puede consultar esta lista para encontrar la Política de
                Privacidad para cada uno de los socios publicitarios de "La Cena
                Que Te Salva". Nuestros servidores de anuncios de terceros o
                redes de anuncios utilizan tecnologías como cookies, JavaScript
                o Web Beacons que se utilizan en sus respectivos anuncios y
                enlaces que aparecen en "La Cena Que Te Salva".
              </p>
              <h3 className="text-xl font-semibold" data-id="element-166">
                Derechos de Privacidad CCPA (No Vender Mi Información Personal)
              </h3>
              <p data-id="element-167">
                Según la CCPA, entre otros derechos, los consumidores de
                California tienen derecho a: Solicitar que una empresa que
                recopila datos personales de un consumidor revele las categorías
                y piezas específicas de datos personales que una empresa ha
                recopilado sobre los consumidores.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-168">Información de Niños</h3>
              <p data-id="element-169">
                Otra parte de nuestra prioridad es añadir protección para los
                niños mientras usan Internet. Animamos a los padres y tutores a
                observar, participar y/o monitorear y guiar su actividad en
                línea. "La Cena Que Te Salva" no recopila a sabiendas ninguna
                Información Personal Identificable de niños menores de 13 años.
              </p>
              <h3 className="text-xl font-semibold" data-id="element-170">Consentimiento</h3>
              <p data-id="element-171">
                Al utilizar nuestro sitio web, usted consiente nuestra Política
                de Privacidad y acepta sus términos.
              </p>
            </div>
          </div>
        </div>}
    </footer>;
};
export default Footer;